var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var MODULE_KEYS = new Set(['series', 'dashboard', 'diagram', 'automotive', 'mode', 'background']);
/** Split a theme pack into UI input + module packs. */
export function splitThemePack(pack) {
    var e_1, _a;
    var ui = {};
    var series;
    var dashboard;
    var diagram;
    var automotive;
    var background;
    try {
        for (var _b = __values(Object.entries(pack !== null && pack !== void 0 ? pack : {})), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (value === undefined)
                continue;
            if (key === 'series' && Array.isArray(value)) {
                series = value.filter(function (c) { return typeof c === 'string'; });
                continue;
            }
            if (key === 'dashboard' && value && typeof value === 'object' && !Array.isArray(value)) {
                dashboard = value;
                continue;
            }
            if (key === 'diagram' && value && typeof value === 'object' && !Array.isArray(value)) {
                diagram = value;
                continue;
            }
            if (key === 'automotive' && (value === 'classic' || value === 'sport' || value === 'digital')) {
                automotive = value;
                continue;
            }
            if (key === 'background' && typeof value === 'string') {
                background = value;
                continue;
            }
            if (!MODULE_KEYS.has(key)) {
                ui[key] = value;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { ui: ui, series: series, dashboard: dashboard, diagram: diagram, automotive: automotive, background: background };
}
/** Shallow-merge theme packs (module objects merge; series replaces when provided). */
export function mergeThemePacks(base, patch) {
    var _a, _b, _c, _d, _e;
    var a = splitThemePack(base);
    var b = splitThemePack(patch);
    var next = __assign(__assign({}, a.ui), b.ui);
    var series = (_a = b.series) !== null && _a !== void 0 ? _a : a.series;
    if (series === null || series === void 0 ? void 0 : series.length)
        next.series = series;
    if (a.dashboard || b.dashboard) {
        next.dashboard = __assign(__assign({}, a.dashboard), b.dashboard);
    }
    if (a.diagram || b.diagram) {
        next.diagram = __assign(__assign({}, a.diagram), b.diagram);
    }
    if ((_b = b.automotive) !== null && _b !== void 0 ? _b : a.automotive) {
        next.automotive = (_c = b.automotive) !== null && _c !== void 0 ? _c : a.automotive;
    }
    if ((_d = b.background) !== null && _d !== void 0 ? _d : a.background) {
        next.background = (_e = b.background) !== null && _e !== void 0 ? _e : a.background;
    }
    return next;
}
/** Normalize unknown JSON into a ThemePack (accepts nested `tokens` object). */
export function normalizeThemePack(raw) {
    var e_2, _a;
    if (!raw || typeof raw !== 'object' || Array.isArray(raw))
        return {};
    var o = raw;
    var pack = {};
    // Nested tokens: { preset, tokens: { primary } }
    if (o.tokens && typeof o.tokens === 'object' && !Array.isArray(o.tokens)) {
        Object.assign(pack, o.tokens);
    }
    try {
        for (var _b = __values(Object.entries(o)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (key === 'tokens' || key === 'mode' || value === undefined)
                continue;
            pack[key] = value;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return pack;
}
/**
 * Extract `theme` from scene JSON and return the scene without it.
 * Supports root `{ theme, type, children }` or `{ theme, children }`.
 */
export function extractSceneTheme(data) {
    if (!('theme' in data) || data.theme === undefined || data.theme === null) {
        return { theme: null, scene: data };
    }
    var theme = normalizeThemePack(data.theme);
    var rest = __assign({}, data);
    delete rest.theme;
    return { theme: theme, scene: rest };
}
/** Build stored pack from split parts (for getTheme / export). */
export function composeThemePack(ui, modules) {
    var _a;
    if (modules === void 0) { modules = {}; }
    var pack = __assign({}, ui);
    if ((_a = modules.series) === null || _a === void 0 ? void 0 : _a.length)
        pack.series = modules.series;
    if (modules.dashboard && Object.keys(modules.dashboard).length) {
        pack.dashboard = __assign({}, modules.dashboard);
    }
    if (modules.diagram && Object.keys(modules.diagram).length) {
        pack.diagram = __assign({}, modules.diagram);
    }
    if (modules.automotive)
        pack.automotive = modules.automotive;
    if (modules.background)
        pack.background = modules.background;
    return pack;
}
/** True when pack has any user intent (not empty). */
export function isThemePackEmpty(pack) {
    return Object.keys(pack).length === 0;
}
